module.exports = __webpack_public_path__ + "img/management-team.8012c6cb.svg";